const euddSupportedCountryCodes = ['AT', 'BE', 'CY', 'DE', 'ES', 'FI', 'FR', 'GB', 'GR', 'IE', 'IT', 'LU', 'MC', 'MT', 'NL', 'PT', 'SI', 'SK']
const echeckMaxAccountNumberLength = 17
const accountNumberRegex = /^[0-9A-Z\s-/]+$/
const bicRegex = /^[A-Za-z]{6}(\w{2}|\w{5})$/
const ibanRegex = /^[A-Za-z]{2}\w{13,40}$/

const validateAccountNumber = number => number.length <= echeckMaxAccountNumberLength
  && accountNumberRegex.test(number)

const validateBIC = bic => bicRegex.test(bic)
  && euddSupportedCountryCodes.indexOf(bic.substring(4, 6)) > -1

const validateIBAN = iban => ibanRegex.test(iban)
  && euddSupportedCountryCodes.indexOf(iban.substring(0, 2)) > -1

const accountNumberValidatorBuilder = () => value => {
  if (!validateAccountNumber(value && value.toUpperCase())) {
    return 'passport.lib.components.payment.echeck.valid.account.number'
  }
  return undefined
}

export {
  validateBIC,
  validateIBAN,
  accountNumberValidatorBuilder,
}
